import { render, staticRenderFns } from "./InfoGrid.vue?vue&type=template&id=77de045e"
import script from "./InfoGrid.vue?vue&type=script&lang=ts"
export * from "./InfoGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77de045e')) {
      api.createRecord('77de045e', component.options)
    } else {
      api.reload('77de045e', component.options)
    }
    module.hot.accept("./InfoGrid.vue?vue&type=template&id=77de045e", function () {
      api.rerender('77de045e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/InfoGrid.vue"
export default component.exports